export default __webpack_public_path__ + "static/media/qp.64915f87.png";